<template>
    <CompassTag :size="size" :color="information.color" :icon="information.icon">
        {{ label }}
    </CompassTag>
</template>
<script>
import { importStatus } from 'Dictionaries/statusColors';
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'small',
        },
    },
    computed: {
        information() {
            return importStatus[this.status];
        },
    },
};
</script>
